import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/" className="nav-logo-link">
            <img src="/icon.png" alt="Forensic AI Logo" className="nav-logo-img" />
            <span className="nav-logo-text">Forensic AI</span>
          </Link>
        </div>
        
        <div className="nav-links">
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            <i className="fas fa-home"></i>
            <span>Dashboard</span>
          </Link>
          <Link 
            to="/analysis" 
            className={`nav-link ${isActive('/analysis') ? 'active' : ''}`}
          >
            <img src="/icon.png" alt="AI Analysis" className="nav-link-icon" />
            <span>AI Analysis</span>
          </Link>
          <Link 
            to="/get-plan" 
            className={`nav-link ${isActive('/get-plan') ? 'active' : ''}`}
          >
            <i className="fas fa-clipboard-list"></i>
            <span>Get Plan</span>
          </Link>
          <Link 
            to="/cases" 
            className={`nav-link ${isActive('/cases') ? 'active' : ''}`}
          >
            <i className="fas fa-folder-open"></i>
            <span>Cases</span>
          </Link>
          <Link 
            to="/documents" 
            className={`nav-link ${isActive('/documents') ? 'active' : ''}`}
          >
            <i className="fas fa-file-alt"></i>
            <span>Documents</span>
          </Link>
        </div>

        <div className="nav-actions">
          <button onClick={handleLogout} className="nav-logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
